
export default {
  name: "Navbar",
};
